import { Component } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  status: boolean;
  value;
  valueStatus;
  submitted;

  loginForm = new FormGroup({
    email: new FormControl(''),
    password: new FormControl(''),
  });

  handleChange(): void {
    this.value = this.loginForm.value;
    this.valueStatus =
      this.loginForm.value.email && this.loginForm.value.password;
    this.focusOut(undefined, this.loginForm.value.email);
    this.submitted = this.valueStatus && this.status;
  }

  focusOut(event, submitValue = undefined) {
    const email = event?.target.value || submitValue;
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    this.status = re.test(String(email).toLowerCase());
  }
}
